// Keuzelijsten voor opdrachten (Belgische context)

export const PROVINCIES = [
  { groep: "België", opties: [
    "Antwerpen", "Oost-Vlaanderen", "West-Vlaanderen", "Vlaams-Brabant", "Limburg (BE)",
    "Henegouwen", "Luik", "Luxemburg", "Namen", "Waals-Brabant", "Brussel",
  ]},
  { groep: "Nederland", opties: [
    "Groningen", "Friesland", "Drenthe", "Overijssel", "Flevoland", "Gelderland",
    "Utrecht", "Noord-Holland", "Zuid-Holland", "Zeeland", "Noord-Brabant", "Limburg (NL)",
  ]},
];

export const PROVINCIE_LIJST = PROVINCIES.flatMap((g) => g.opties);

export const OP_ZOEK_NAAR = [
  "Nieuwe ramen en deuren",
  "Dakramen (Velux of ander merk)",
  "Monteur voor plaatsing ramen en deuren",
  "Monteur voor plaatsing dakraam",
  "Advies over ramen en deuren",
  "Advies over dakramen",
];

export const VERGOEDINGSTYPES = [
  { value: "projectprijs", label: "Projectprijs" },
  { value: "uurtarief", label: "Uurtarief" },
  { value: "offerte", label: "Eerst offerte maken" },
];

export const WERK_TYPES = [
  { value: "monteren", label: "Ramen en/of deuren monteren" },
  { value: "binnenafwerking", label: "Ramen en/of deuren binnen afwerken" },
  { value: "elastisch_voegen", label: "Elastisch voegen" },
  { value: "rolluiken", label: "Rolluiken monteren en afstellen" },
  { value: "screens", label: "Screens monteren" },
];

export const WERK_TYPE_LABELS = {
  monteren: "Ramen/deuren monteren",
  binnenafwerking: "Binnenafwerking",
  elastisch_voegen: "Elastisch voegen",
  rolluiken: "Rolluiken",
  screens: "Screens",
};

export function typesLabel(job) {
  const arr = (job.types || []).map((t) => WERK_TYPE_LABELS[t] || t);
  if (job.type_andere) arr.push(job.type_andere);
  if (arr.length === 0 && job.type) return job.type; // oudere opdrachten
  return arr.join(", ") || "—";
}

export function pricingLabel(job) {
  if (job.vergoedingstype === "uurtarief") return "Uurtarief (onderling af te spreken)";
  if (job.vergoedingstype === "projectprijs") return "Projectprijs (onderling af te spreken)";
  if (job.vergoedingstype === "offerte") return "Offerte op aanvraag";
  if (job.uurtarief) return `€${job.uurtarief}/uur`; // oudere opdrachten
  return "—";
}

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function fileUrl(id) {
  return `${API_BASE}/files/${id}`;
}

